export default data => {
  const str = `
    <div class="card__visual">
      <img src="${data.imgSrc}" alt="">
    </div>
    <div class="card__inner">
      <div class="card__top">
         <div class="card__content">
         <a href="${data.url}">
            <h2 class="card__title">${data.title}</h2>
          </a>
          <div class="card__text">
            ${data.desc}
          </div>
         </div>
        </div>
        <div class="card__bottom">
          <a href="https://${data.website}" target="_blank" rel="nofollow">
            ${data.website}
          </a>
        </div>
      </div>`

  return str
}
